<template>
    <div id="app">
        <b-row>
            <b-col>
                <p id="logo"><img src="@/assets/img/Otelico-logo-text-bleu.png" /></p>

            </b-col>
        </b-row>
        <router-view />
    </div>
</template>

<script>
    // import Questionnaire from './components/Questionnaire.vue'

    export default {
        name: 'app',
        // components: {
        //     Questionnaire
        // }
    }
</script>

<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: left;
        color: #2c3e50;
        margin-top: 40px;

        #logo {

            text-align: center;

            img {
                max-width: 300px;
            }
        }

        fieldset.inline {
            background: #f1f1f1;
            padding: 20px;
            margin-bottom: 30px;

            h3 {
                text-align: left;
            }

            .form-group {
                display: flex;

                label:not(.custom-control-label) {
                    width: 35%;
                    margin-right: 30px;
                    text-align: right;
                }

                div {
                    flex: 1;
                    text-align: left;
                }

                .input-group-append {
                    flex: 0;
                }

                .custom-switch {
                    text-align: left;
                }
            }
        }



    }
</style>